import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InviteUserComponent } from './invite-user/invite-user.component';
import { SelectSubdomainComponent } from './select-subdomain/select-subdomain.component';

const routes: Routes = [
	{
		path: 'settings',
		loadChildren: () =>
			import('./settings/settings.module').then(
				(m) => m.SettingsModule,
			),
	},
	{ path: 'account', component: SelectSubdomainComponent },
	{ path: 'invite/user', component: InviteUserComponent },
	{
		path: '',
		loadChildren: () =>
			import('./auth/auth.module').then(
				(m) => m.AuthModule,
			),
	},
	// {
	// 	path: '',
	// 	// component: LoginComponent,
	// 	redirectTo: 'login',
	// 	pathMatch: 'full',
	// },
	// { path: '**', redirectTo: '' },
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
